import { type PropsWithChildren } from 'react';
import { type PermissionOptions, useCheckPermissions } from './permissionContext';

type CanProps = PropsWithChildren<
  PermissionOptions & {
    /**
     * Optional allowed permissions to check against.
     * If not provided, the permissions from the PermissionsProvider will be used.
     */
    allowedPermissions?: string[];

    /**
     * Optional flag to invert the permission check.
     */
    not?: boolean;
  }
>;

/**
 * Render the children if the user has the permission.
 * It must be used within a PermissionsProvider.
 */
export const Can = ({ children, allowedPermissions, I, a, an, this: thisProp, scope, not }: CanProps) => {
  const { can } = useCheckPermissions();
  const hasPermission = can({ I, a, an, this: thisProp, scope }, allowedPermissions);
  if (not) {
    return hasPermission ? null : children;
  }
  return hasPermission ? children : null;
};
